import React from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import BaseLayout, {BaseLayoutProps} from '../BaseLayout/BaseLayout';

import styles from './BlankLayout.module.scss';

const BlankLayout: React.FC<BaseLayoutProps> = (props) => {

    return (
        <BaseLayout {...props}>
            <div className={cn(
                styles.wrapper,
                isTranslate() ? styles.enWrapper : styles.ruWrapper,
            )}
            >
                {props.children}
            </div>
        </BaseLayout>
    );
};

export default BlankLayout;